const BOLD_TAG = 'b';
const BUTTON = 'button';
const CODE = 'code';
const BUTTON_ICON = 'button--icon';
const ICON_BUTTON = 'icon-button';
const AND = 'AND';
const OR = 'OR';
const AND_OPERATOR = 'must';
const OR_OPERATOR = 'should';
const TEXT_SEARCH = 'text-search';
const INFINITE = 'infinite';
const CLASSIC = 'classic';
const SEARCH_PUBLISHED_CONTENT = 'searchPublishedContent';
const SEARCH = 'search';
const SEARCH_TERM = 'search_term';
const RANGE = 'range';
const CHECKBOX = 'checkbox';
const ELEMENT = 'element';
const MENU_ITEM = 'menuitem';
const SUB_MENU = 'submenu';
const SELECT = 'select';
const ON_CLICK = 'onClick';
const KEYWORD = 'keyword';
const DEFAULT_LIMIT = 50;
const DEFAULT_OFFSET = 0;
const MOBILE_WIDTH = 768;
const FEATURED = 'featured';
const SPONSORED = 'sponsored';
const STRING = 'string';
const OBJECT = 'object';
const DATE = 'date';
const FULL = 'full';
const CHILD_PROPS_TO_USE = ['width'];
const CATEGORY_ID = 'categoryId';
const PUBLISHED = 'published';
const ID = 'id';
const LINK = 'link';
const LOGOUT = 'logout';
const GRAPH_QL_ERROR = 'GraphQL error: ';
const HOVER = 'hover';
const MOUSE_ENTER = 'mouseenter';
const MOUSE_LEAVE = 'mouseleave';
const CLICK = 'click';
const HIDE = 'hide';
const SHOW = 'show';
const VISIBLE = 'visible';
const INVISIBLE = 'invisible';
const HIDDEN = 'hidden';
const CLASS_MODIFIERS = {
  MODIFIER: 'modifier',
  GTM_CLASS_NAME: 'gtmClassName',
  HIDE: 'hide',
  DESKTOP: 'desktop',
  DEFAULT: 'default',
  TABLET: 'tablet',
  MOBILE: 'mobile',
  SIZE: 'size',
  BUTTON_TYPE: 'buttonType',
  ICON: 'icon',
  STYLE: 'style',
  WIDTH: 'width',
  STICKY: 'sticky',
  ALIGNMENT: 'alignment',
  PARALLAX: 'parallax'
};
const CAROUSEL = 'carousel';
const IMAGE = 'image';
const IMAGES = `${IMAGE}s`;
const IMAGE_WRAPPER = 'image__wrapper';
const END_ADUNIT = 'root';
const COUNT_CONTENT_HIERARCHIES = 'countContentHierarchies';
const GET_BANNER = 'getBanner';
const WIDTH_HEIGHT = 'width height';
const BANNER_QUERY_PROPS = `sizes { ${WIDTH_HEIGHT} viewports { ${WIDTH_HEIGHT} } }`;
const WAYPOINT_BOTTOM_OFFSET = '-200px';
const IN_VIEW_CONFIG = {
  once: true,
  offset: '200px',
  bottomOffset: '-200px'
};
const HERO = 'hero';
const HERO_WRAPPER = 'hero__wrapper';
const GET_FILE_FALLBACK = {
  getFile: {
    url: '',
    data: {}
  }
};
const WITH_BANNER = ' with-banner';
const BLANK_SPACE_UNICODE_STRING = '\u00A0';
const ALL = 'ALL';
const COLUMN = 'column';
const ROW = 'row';
const GTM = 'gtm';
const GTM_DATA_ID_ATTR = 'data-gtm-id';
const CENTER = 'center';
const HALF = 'half';
const WIDE = 'wide';
const DESK = 'desk';
const TABLET = 'tablet';
const MOBILE = 'mobile';
const ALIGNMENT = 'alignment';
const PAGINATION_QUERY_CONST = '[page]';
const AZ_QUERY_CONST = '[aZ]';
const PB_QUERY_CONST = 'pb';
const NEXT_STRING = 'Next';
const PREVIOUS_STRING = 'Previous';
const LOAD_MORE_STRING = 'Load More';
const LOAD_MORE = 'loadMore';
const PAGINATION_DISPLAY_LIMIT = 10;
const PAGINATION_DIFFERENCE = 5;
const PROPS_TO_CHECK = [['altText', 'alt'], ['caption', 'caption'], ['hrefUrl', 'hrefUrl'], ['credits', 'credits']];
const JW_PLAYER_TYPE_FILE = 'file';
const VIDEO_WRAPPER_CLASS_NAME = 'video__wrapper';
const VIMEO_OEMBED_URL = 'https://vimeo.com/api/oembed.json';
const BREAKPOINT_SIZES = {
  sm: 'sm',
  md: 'md',
  lg: 'lg',
  xl: 'xl',
  xxl: '2xl'
};
const MAX_BANNER_HEIGHT = 250;
const MIN_BANNER_HEIGHT = 90;
const ALLOWED_BLOCK_TYPES = ['p', 'ul', 'ol'];
const PREHEADER_PROP = 'alternativePreHeader';
const HEADLINE_PROP = 'alternativeHeadline';
const AZ = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
const AZ_DEFAULT_PROP = 'name';
const SCROLL_OFFSET = process.env.BLAZE_SCROLL_OFFSET || 50;
const BANNER_LOADING = 'loading';
const BANNER_EMPTY = 'empty';
const BANNER_LOADED = 'loaded';
const ANCHOR_TAG = 'a';
const TARGET_BLANK = '_blank';
const DATA_SUMMARY_EMAIL_REGEX = /^([a-z0-9_\.\+-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})$/;
const DATA_SUMMARY_URL_REGEX = /(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;
const DATA_SUMMARY_TEL_REGEX = /^\+{0,1}[0-9\(\)\.\- \/]{7,}$/; // note: very loose phone number match not for validation
const SIZE = process.env.BLAZE_PB_SEARCH_FILETER_AGG_SIZE || 500;
export { BANNER_LOADING, BANNER_EMPTY, BANNER_LOADED, BLANK_SPACE_UNICODE_STRING, BOLD_TAG, BUTTON, BUTTON_ICON, ICON_BUTTON, AND, AND_OPERATOR, OR_OPERATOR, TEXT_SEARCH, SEARCH_PUBLISHED_CONTENT, SEARCH, SEARCH_TERM, RANGE, CHECKBOX, SELECT, KEYWORD, OR, DEFAULT_LIMIT, DEFAULT_OFFSET, FEATURED, SPONSORED, STRING, DATE, FULL, CHILD_PROPS_TO_USE, CATEGORY_ID, PUBLISHED, ID, LINK, CLASS_MODIFIERS, END_ADUNIT, COUNT_CONTENT_HIERARCHIES, GET_BANNER, BANNER_QUERY_PROPS, CAROUSEL, IMAGE, IMAGES, IMAGE_WRAPPER, IN_VIEW_CONFIG, GET_FILE_FALLBACK, HERO, HERO_WRAPPER, WITH_BANNER, ALL, COLUMN, ROW, GTM, GTM_DATA_ID_ATTR, PROPS_TO_CHECK, CENTER, HALF, WIDE, DESK, TABLET, MOBILE, ALIGNMENT, OBJECT, ON_CLICK, WAYPOINT_BOTTOM_OFFSET, JW_PLAYER_TYPE_FILE, CODE, VIDEO_WRAPPER_CLASS_NAME, PAGINATION_QUERY_CONST, PB_QUERY_CONST, INFINITE, NEXT_STRING, PREVIOUS_STRING, PAGINATION_DISPLAY_LIMIT, PAGINATION_DIFFERENCE, LOAD_MORE_STRING, LOAD_MORE, CLASSIC, BREAKPOINT_SIZES, LOGOUT, MIN_BANNER_HEIGHT, MAX_BANNER_HEIGHT, GRAPH_QL_ERROR, HOVER, MOUSE_ENTER, MOUSE_LEAVE, CLICK, SHOW, HIDE, VISIBLE, INVISIBLE, MOBILE_WIDTH, HIDDEN, MENU_ITEM, SUB_MENU, ELEMENT, ALLOWED_BLOCK_TYPES, PREHEADER_PROP, HEADLINE_PROP, AZ_QUERY_CONST, AZ_DEFAULT_PROP, AZ, SCROLL_OFFSET, ANCHOR_TAG, TARGET_BLANK, DATA_SUMMARY_EMAIL_REGEX, DATA_SUMMARY_URL_REGEX, DATA_SUMMARY_TEL_REGEX, VIMEO_OEMBED_URL, SIZE };
//# sourceMappingURL=index.js.map